<template>
<vs-select :value="selectedConditionCase" @input="onSelected" class="mt-2" color="primary">
  <vs-select-item
    v-for="(conditionCase, index) of conditionCases"
    :key="index"
    :value="conditionCase.id"
    :text="conditionCase.title" />
</vs-select>
</template>

<script>
import { CONDITION_CASES } from '@/store/constants'
import conditionUtils from '@/utils/condition.utils'
import { CUSTOMERS_URL_LABEL } from '@/utils/key-regex.constants'
import botModule from '@/store/modules/bot.module'

export default {
  props: {
    selectedConditionCase: {
      type: String,
      required: true
    }
  },

  computed: {
    isEmailBot() {
      return botModule.isEmailBot()
    },

    conditionCases() {
      const cases = [
        {
          id: CONDITION_CASES.OPERATOR_AVAILABLE,
          title: 'Operator Status'
        },
        {
          id: CONDITION_CASES.DAY,
          title: 'Day'
        },
        {
          id: CONDITION_CASES.TIME_BETWEEN,
          title: 'Time Between'
        },
        {
          id: CONDITION_CASES.CHANNEL_TYPE,
          title: 'Channel'
        },
        {
          id: CONDITION_CASES.BROWSER_URL,
          title: CUSTOMERS_URL_LABEL
        },
        {
          id: CONDITION_CASES.CONTEXT,
          title: 'Context'
        }
      ]
      if (this.isEmailBot) {
        cases.push({
          id: CONDITION_CASES.CONTEXT_CHATGPT_CALL_OPERATOR,
          title: 'AI Call Operator'
        })
      }
      return cases
    }
  },

  methods: {
    onSelected(value) {
      if (value === this.selectedConditionCase) return

      this.$emit('expression-change', conditionUtils.createConditionJson(value))
    }
  }
}
</script>
